/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../typography/Typography';
import { Eyebrow } from './Eyebrow';

const defaultVariantMap = {
  h3: {
    variant: 'h3',
    height: 'snug',
    weight: 'condensed',
    lineClamp: '3'
  },
  h5: {
    variant: 'h5',
    height: 'snug',
    weight: 'condensed',
    lineClamp: '3'
  }
};

const CardTitle = ({
  header,
  subheader,
  eyebrow,
  eyebrowOrnament,
  headerOrnament,
  action,
  headerVariant = 'h3'
}) => {

  const headerTypographyProps = defaultVariantMap[headerVariant];
  const hasEyebrow = eyebrow || eyebrowOrnament;
  const isIconButton = action && action.type.displayName === 'IconButton';

  const actionItem = (
    <span className={isIconButton ? 'sui--top-2 sui--right-3 sui-relative' : ''}>
      {action}
    </span>
  );

  return (
    <>
      <div className="sui-flex sui-flex-col sui-w-full">
        {hasEyebrow && (
          <div className="sui-flex sui-items-start sui-relative">
            <Eyebrow title={eyebrow} ornament={eyebrowOrnament} />
            {actionItem}
          </div>
        )}
        <div className="sui-flex-auto sui-text-left">
          <div className="sui-flex sui-items-start sui-relative">
            {headerOrnament && (
              <span className="sui-mr-2">
                {headerOrnament}
              </span>
            )}
            {header && (
              <div className="sui-grow">
                <Typography {...headerTypographyProps}>{header}</Typography>
              </div>
            )}
            {!hasEyebrow && actionItem}
          </div>
          {subheader && (
            <Typography color="subtle">{subheader}</Typography>
          )}
        </div>
      </div>
    </>
  );
};

CardTitle.displayName = 'CardTitle';

CardTitle.propTypes = {
  /**
   * The contents of the eyebrow.
   */
  eyebrow: PropTypes.string,
  /**
   * The leading ornament within the eyebrow.
   */
  eyebrowOrnament: PropTypes.node,
  /**
   * The contents of the header.
   */
  header: PropTypes.string,
  /**
   * The contents of the subheader.
   */
  subheader: PropTypes.string,
  /**
   * The typography variant to use in header.
   */
  headerVariant: PropTypes.oneOf(['h3', 'h5']),
  /**
   * The leading ornament within the eyebrow.
   */
  headerOrnament: PropTypes.node,
  /**
   * The action ornament, button or link of the title
   */
  action: PropTypes.node
};

CardTitle.defaultProps = {};

export { CardTitle };